import React from 'react';

const AllergenSelection = ({allergens, handleAllergenChange}) => {
    const allergenList = [
        'wheat', 'eggs', 'crustaceans_shell_fish', 'fish', 'milk', 'tree_nuts',
        'peanuts', 'soy', 'sesame_seeds', 'celery', 'barley_oats_rye_spelt',
        'orange_kiwi_peaches_apples', 'mushrooms', 'mustard', 'lupin', 'molluscs'
    ];

    return (
        <div>
            <h2 className="text-xl md:text-center font-semibold tracking-wider mb-10">Allergen Selection</h2>
            <form className="space-y-6">
                {allergenList.map((allergen) => (
                    <div key={allergen} className="grid grid-cols-1 sm:grid-cols-2 sm:items-center sm:justify-center gap-2 mt-3">
                        {/* flex flex-col sm:flex-row flex-start space-y-2 sm:space-x-2 sm:space-y-0 sm:w-3/4 mb-2 */}
                        <label className="font-semibold capitalize md:text-center w-full sm:w:1/3">{allergen.replace(/_/g, ' ')}</label>
                        <select
                            name={allergen}
                            value={allergens[allergen]}
                            onChange={handleAllergenChange}
                            className="w-full sm:w-3/4 md:w-3/4 lg:w-3/4 xl:w-3/4 border border-gray-600 rounded px-4 py-2 bg-gray-700 text-gray-200 "
                        >
                            <option value="">Select</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                ))}
            </form>
        </div>
    );
};

export default AllergenSelection;
